var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssinaturaEletronica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.274,
    height: 18.211,
    viewBox: "0 0 18.274 18.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assinatura-eletronica",
    transform: "translate(-2 -2.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M13.627,2.888a2.839,2.839,0,0,1,4.011,4.019L16.163,8.385l.1.1a2.328,2.328,0,0,1,0,3.288l-1.67,1.673a.581.581,0,1,1-.82-.822l1.67-1.673a1.164,1.164,0,0,0,0-1.644l-.1-.1L7.631,16.934a.581.581,0,0,1-.269.153L2.721,18.249A.581.581,0,0,1,2.03,17.5l1.45-4.359a.581.581,0,0,1,.14-.227Z",
    transform: "translate(0 0)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M3.276,16.9l-.059-.038,1.556-.337A5.56,5.56,0,0,0,7,17a4.012,4.012,0,0,0,1.77-.474,13.586,13.586,0,0,0,1.761-1.1l.15-.106a13.489,13.489,0,0,1,1.543-.991,2.566,2.566,0,0,1,1.882-.3c.948.274,1.247,1.03,1.524,1.831a1.293,1.293,0,0,0,.3.489.443.443,0,0,0,.3.154,2.262,2.262,0,0,0,.92-.3c.249-.127.465-.257.678-.385.13-.078.26-.156.4-.232a6.836,6.836,0,0,1,.913-.431c.115-.044.208-.075.275-.1l.081-.024.025-.007.008,0h0l.162.48c-.161-.48-.162-.48-.162-.48a.6.6,0,0,1,.716.341.494.494,0,0,1-.391.619l-.008,0L19.806,16c-.044.014-.112.036-.2.07a5.615,5.615,0,0,0-.748.354c-.082.046-.186.108-.3.178-.24.143-.536.319-.811.46a3.445,3.445,0,0,1-1.506.442,1.657,1.657,0,0,1-1.163-.49,2.258,2.258,0,0,1-.544-.867c-.3-.876-.478-1.081-.784-1.169a1.322,1.322,0,0,0-.931.214,12.67,12.67,0,0,0-1.417.917l-.135.1A14.674,14.674,0,0,1,9.346,17.4,5.285,5.285,0,0,1,7,18,6.974,6.974,0,0,1,3.276,16.9Z",
    transform: "translate(0 2.266)",
    fill: "#2d2d2d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssinaturaEletronica);
export default __webpack_public_path__ + "static/media/assinatura-eletronica.0e4f6fbf92889867c6340302351a9ca9.svg";
export { ForwardRef as ReactComponent };